import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// TODO: import material-design-icons-iconfont if necessary like in zfp-admin

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#1F6318',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        farmer_green: '#1F6318',
        farmer_grey: '#EAEDED',
        farmer_teal: '#1C8484'
      }
    }
  },
  icons: {
    iconfont: 'md'
  }
})
